<template>
    <div class="proposal-table p-3">
        <b-table-simple responsive bordered v-if="financial_proposal">
            <b-thead>
                <b-tr>
                    <b-th>Type</b-th>
                    <b-th>Before (RM)</b-th>
                    <b-th>After (RM)</b-th>
                </b-tr>
            </b-thead>
            <!-- Cash Inflow Start -->
            <b-tbody v-if="financial_proposal.customer_incomes">
                <b-tr style="background: #FFF8B4;">
                    <b-td colspan="3">
                        <h3 class="mb-0">Cash Inflow</h3>
                    </b-td>
                </b-tr>
                <b-tr v-for="item in financial_proposal.customer_incomes.data"
                    :key="'income_' + item.customer_income_id">
                    <template v-if="item.object_title != 'net_income'">
                        <b-td v-if="item.object_title != 'minus_info'">{{ item.income_type_title }}</b-td>
                        <b-td v-else>(-) {{ item.income_type_title }}</b-td>
                        <b-td>{{ item.customer_value | moneyFormatter }}</b-td>
                        <b-td>
                            <CurrencyInput v-if="item.object_title !== 'gross_income'" v-model="item.admin_value"
                                :disabled="item.object_title == 'net_income' || item.object_title == 'gross_income'"
                                v-on:input="updateAdminValue('customer_income', item.customer_income_id, item.admin_value, item.object_title)"
                                :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                                :style="{ ...getInputStyle(item.admin_value, item.customer_value), color: 'black', fontWeight: 'bold' }" />
                            <CurrencyInput v-if="item.object_title == 'gross_income'" v-model="customer_manual_gross_income"
                                :disabled="true"
                                :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                                :style="{ ...getInputStyle(item.admin_value, item.customer_value), color: 'black', fontWeight: 'bold' }" />
                        </b-td>
                    </template>
                </b-tr>
                <b-tr class="font-weight-600">
                    <b-td class="border-right-0">
                        <h3 class="mb-0">Net Income</h3>
                        <!-- <b-form-checkbox class="text-muted" v-model="is_manual_net_income">
                            Override
                        </b-form-checkbox> -->
                    </b-td>
                    <b-td class="border-right-0 border-left-0">
                        <h3 class="mb-0">{{ financial_proposal.customer_incomes.total.customer_value | moneyFormatter }}
                        </h3>
                    </b-td>
                    <b-td class="border-left-0" v-if="is_manual_net_income">
                        <CurrencyInput v-model="customer_manual_net_income" :disabled="true"
                            :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                            :style="{ ...getInputStyle(customer_manual_net_income, financial_proposal.customer_incomes.total.customer_value), color: 'black', fontWeight: 'bold' }" />
                    </b-td>
                    <b-td class="border-left-0" v-else>
                        <h3 class="mb-0">{{ financial_proposal.customer_incomes.total.admin_value | moneyFormatter }}
                        </h3>
                    </b-td>

                </b-tr>
            </b-tbody>
            <!-- Cash Inflow End -->

            <!-- Cash Outflow Start -->
            <b-tbody>
                <b-tr style="background: #FFF8B4;">
                    <b-td colspan="3">
                        <h3 class="mb-0">Cash Outflow</h3>
                    </b-td>
                </b-tr>

                <!-- Fixed Commitments Start -->
                <b-tr style="background: #FFFDEC;">
                    <b-td colspan="3">
                        <p class="font-weight-600">Fixed Commitments</p>
                    </b-td>
                </b-tr>
                <b-tr v-for="item in financial_proposal.customer_liabilities"
                    :key="'liability_' + item.customer_liability_id">
                    <b-td class="custom-width">{{ item.loan_statue_name }}</b-td>
                    <b-td>{{ item.customer_curr_installment | moneyFormatter }}</b-td>
                    <b-td>
                        <CurrencyInput v-model="item.admin_curr_installment"
                            v-on:input="updateData(item.customer_liability_id, item.admin_curr_installment)"
                            :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                            :style="{ ...getInputStyle(item.admin_curr_installment, item.customer_curr_installment), color: 'black', fontWeight: 'bold' }" />
                    </b-td>
                </b-tr>
                <b-tr>
                    <b-td class="border-right-0">
                        <p class="font-weight-600">Total Fixed Commitments</p>
                    </b-td>
                    <b-td class="border-right-0 border-left-0">
                        <p class="font-weight-600">{{ form_data_total.customer_commitments.customer_value |
            moneyFormatter }}</p>
                    </b-td>
                    <b-td class="border-left-0">
                        <p class="font-weight-600">{{ form_data_total.customer_commitments.admin_value | moneyFormatter
                            }}</p>
                    </b-td>
                </b-tr>
                <!-- Fixed Commitments End -->

                <!-- Variable Expenses Start -->
                <b-tr style="background: #FFFDEC;">
                    <b-td colspan="3">
                        <p class="font-weight-600">Variable Expenses (month)</p>
                    </b-td>
                </b-tr>
                <b-tr v-for="item in financial_proposal.customer_expenses" :key="'expense_' + item.customer_expense_id">
                    <b-td class="custom-width">{{ item.customer_question_column }}</b-td>
                    <b-td><CurrencyInput v-model="item.customer_month_value" v-on:input="updateExpenseValue(item)"
                            :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                            :style="{ ...getInputStyle(item.customer_month_value, item.customer_month_value), color: 'black', fontWeight: 'bold' }" /></b-td>
                    <b-td>
                        <CurrencyInput v-model="item.admin_month_value" v-on:input="updateExpenseValue(item)"
                            :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                            :style="{ ...getInputStyle(item.admin_month_value, item.customer_month_value), color: 'black', fontWeight: 'bold' }" />
                    </b-td>
                </b-tr>
                <b-tr>
                    <b-td class="border-right-0">
                        <p class="font-weight-600">Total Variable Expenses</p>
                    </b-td>
                    <b-td class="border-right-0 border-left-0">
                        <p class="font-weight-600">{{ form_data_total.customer_expenses.customer_value | moneyFormatter
                            }}</p>
                    </b-td>
                    <b-td class="border-left-0">
                        <p class="font-weight-600">{{ form_data_total.customer_expenses.admin_value | moneyFormatter }}
                        </p>
                    </b-td>
                </b-tr>
                <!-- Variable Expenses End -->

            </b-tbody>
            <!-- Cash Outflow End -->

            <b-tfoot>
                <b-tr>
                    <b-td class="border-right-0">
                        <h3 class="mb-0">Total Outflow</h3>
                    </b-td>
                    <b-td class="border-right-0 border-left-0">
                        <h3 class="mb-0">{{ form_data_total.outflow.customer_value | moneyFormatter }}</h3>
                    </b-td>
                    <b-td class="border-left-0">
                        <h3 class="mb-0">{{ form_data_total.outflow.admin_value | moneyFormatter }}</h3>
                    </b-td>
                </b-tr>
                <b-tr>
                    <b-td class="border-right-0">
                        <h2 class="mb-0 font-weight-700">Net inflow/Outflow</h2>
                    </b-td>
                    <b-td class="border-right-0 border-left-0">
                        <h2 class="mb-0 font-weight-700"
                            :style="{ 'color': form_data_total.net_flow.customer_value < 0 ? '#f5365c' : '' }">{{
            form_data_total.net_flow.customer_value | moneyFormatter }}</h2>
                    </b-td>
                    <b-td class="border-left-0">
                        <h2 class="mb-0 font-weight-700"
                            :style="{ 'color': form_data_total.net_flow.admin_value < 0 ? '#f5365c' : '' }">{{
                            form_data_total.net_flow.admin_value | moneyFormatter }}</h2>
                    </b-td>
                </b-tr>
            </b-tfoot>
        </b-table-simple>
    </div>
</template>
<script>
import { Select, Option } from 'element-ui'
import CurrencyInput from '@/components/CurrencyInput'
import { axios, services, getHeader, notifyFunctionMixin } from '@/assets/js/httpImports.js'
import debounce from 'lodash.debounce';
import initialProposalEventBus from '@/assets/js/EventBus/initialProposalEventBus.js'

export default {
    props: ['financial_proposal'],
    mixins: ['notifyFunctionMixin'],
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        CurrencyInput,
    },
    data() {
        return {
            is_manual_net_income: false,
            is_manual_gross_income: true,
            customer_manual_net_income: null,
            customer_manual_gross_income: null,
            customer_net_income: null,
            cashInflow: [
                {
                    id: 1121,
                    title: 'Salaried',
                    amount_before: 7550,
                    amount_after: 7550,
                },
                {
                    id: 1122,
                    title: 'Fixed Allowance',
                    amount_before: 900,
                    amount_after: 900,
                },
                {
                    id: 1123,
                    title: 'Avg Variable Income',
                    amount_before: 0,
                    amount_after: 0,
                },
                {
                    id: 1124,
                    title: 'Avg Commission',
                    amount_before: 0,
                    amount_after: 500,
                },
                {
                    id: 1125,
                    title: 'Gross Income',
                    amount_before: 8450,
                    amount_after: 8950,
                },
                {
                    id: 1126,
                    title: 'Gross Income',
                    amount_before: 8450,
                    amount_after: 8950,
                },
                {
                    id: 1127,
                    title: 'Avg Bonus',
                    amount_before: 0,
                    amount_after: 0,
                },
                {
                    id: 1128,
                    title: 'Rental Income',
                    amount_before: 0,
                    amount_after: 0,
                },
                {
                    id: 1129,
                    title: '(-) Income Tax',
                    amount_before: 1267,
                    amount_after: 1267,
                },
                {
                    id: 1130,
                    title: '(-) Less: EPF Contribution',
                    amount_before: 900,
                    amount_after: 900,
                },
                {
                    id: 1131,
                    title: '(-) SOCSO',
                    amount_before: 900,
                    amount_after: 900,
                },
            ],
            fixed_comm: [
                {
                    id: 212,
                    title: 'Car Loan',
                    amount_before: 1000,
                    amount_after: 1000,
                },
                {
                    id: 213,
                    title: 'Others Loan',
                    amount_before: 100,
                    amount_after: 100,
                },
                {
                    id: 214,
                    title: 'SAA - Car Loan',
                    amount_before: 250,
                    amount_after: 250,
                },
            ],
            variable_exp: [
                {
                    id: 3211,
                    title: 'Monthly rental',
                    amount_before: 1200,
                    amount_after: 1200,
                },
                {
                    id: 3212,
                    title: 'Monthly phone bill',
                    amount_before: 100,
                    amount_after: 100,
                },
                {
                    id: 3213,
                    title: 'Utilities bill payment',
                    amount_before: 300,
                    amount_after: 300,
                },
                {
                    id: 3214,
                    title: 'Foods',
                    amount_before: 1500,
                    amount_after: 1500,
                },
            ],
            form_data_total: {
                customer_incomes: {},
                customer_commitments: {
                    customer_value: 0,
                    admin_value: 0,
                },
                customer_expenses: {
                    customer_value: 0,
                    admin_value: 0,
                },
                inflow: {
                    customer_value: 0,
                    admin_value: 0,
                },
                outflow: {
                    customer_value: 0,
                    admin_value: 0,
                },
                net_flow: {
                    customer_value: 0,
                    admin_value: 0,
                },
            }
        }
    },
    computed: {

    },
    watch: {
        'financial_proposal.customer_incomes': {
            handler(newVal) {
                if (newVal) {
                    if (this.customer_net_income == null) {
                        this.getCustomerNetIncome()
                    }

                    if (this.customer_manual_gross_income == null) {
                        this.customer_manual_gross_income = this.financial_proposal.customer_incomes.data.find(item => item.object_title == 'gross_income').admin_value;
                    }
                    this.calculateNetFlow();
                }
            },
            immediate: true,
            deep: true,
        },
        'financial_proposal.customer_liabilities': {
            handler(newVal) {
                if (newVal) {
                    if (this.financial_proposal.customer_liabilities.length > 0) {
                        this.form_data_total.customer_commitments = {
                            customer_value: this.financial_proposal.customer_liabilities.reduce((acc, item) => acc + item.customer_curr_installment, 0),
                            admin_value: this.financial_proposal.customer_liabilities.reduce((acc, item) => acc + item.admin_curr_installment, 0),
                        }
                    }

                    this.calculateNetFlow();
                }
            },
            immediate: true,
            deep: true,
        },
        'financial_proposal.customer_expenses': {
            handler(newVal) {
                if (newVal) {
                    if (this.financial_proposal.customer_expenses.length > 0) {
                        this.form_data_total.customer_expenses = {
                            customer_value: this.financial_proposal.customer_expenses.reduce((acc, item) => acc + item.customer_month_value, 0),
                            admin_value: this.financial_proposal.customer_expenses.reduce((acc, item) => acc + item.admin_month_value, 0),
                        }
                    }

                    this.calculateNetFlow();
                }
            },
            immediate: true,
            deep: true,
        },
    },
    methods: {
        replaceNullWithZero(obj) {
            for (const key in obj) {
                if (obj[key] === null) {
                    obj[key] = 0;
                } else if (typeof obj[key] === 'object') {
                    this.replaceNullWithZero(obj[key]);
                } else if (typeof obj[key] === 'number' && isNaN(obj[key])) {
                    obj[key] = 0;
                }
            }
        },
        calculateNetFlow() {
            this.replaceNullWithZero(this.form_data_total);

            this.form_data_total.outflow = {
                customer_value: this.form_data_total.customer_commitments.customer_value + this.form_data_total.customer_expenses.customer_value,
                admin_value: this.form_data_total.customer_commitments.admin_value + this.form_data_total.customer_expenses.admin_value,
            }

            const customer_outflow_value = this.form_data_total.outflow.customer_value;
            const admin_outflow_value = this.form_data_total.outflow.admin_value;

            this.form_data_total.net_flow = {
                customer_value: this.financial_proposal.customer_incomes.total.customer_value - customer_outflow_value,
                admin_value: this.customer_manual_net_income - admin_outflow_value
                // admin_value: this.financial_proposal.customer_incomes.total.admin_value - admin_outflow_value
            }
        },
        updateAdminValue: debounce(function (table_name, customer_income_id, admin_value, object_title) {
            const postData = {
                admin_value: admin_value,
            }
            // console.log(this.financial_proposal.customer_incomes.data)
            // eslint-disable-next-line vue/no-mutating-props
            this.financial_proposal.customer_incomes.data = this.financial_proposal.customer_incomes.data.map(item => {
                if (item.customer_income_id == customer_income_id) {
                    item.admin_value = admin_value;
                }
                return item;
            });

            const getPlusIncome = this.financial_proposal.customer_incomes.data.filter(item => item.object_title == 'plus_info' || item.object_title == 'bonus_income' || item.object_title == 'rental_income');
            const grossIncome = getPlusIncome.reduce((acc, item) => acc + item.admin_value, 0);
            const getMinusItem = this.financial_proposal.customer_incomes.data.filter(item => item.object_title == 'minus_info');
            const netIncome = grossIncome - getMinusItem.reduce((acc, item) => acc + item.admin_value, 0);

            this.customer_manual_net_income = netIncome;
            this.customer_manual_gross_income = grossIncome;

            const grossIncomeItem = this.financial_proposal.customer_incomes.data.find(item => item.object_title == 'gross_income');
            const netIncomeItem = this.financial_proposal.customer_incomes.data.find(item => item.object_title == 'net_income');

            const grossIncomePostData = {
                admin_value: grossIncome,
            }

            const netIncomePostData = {
                admin_value: netIncome,
            }

            Promise.all([
                axios.put(services.financial_proposal + table_name + '/' + grossIncomeItem.customer_income_id, grossIncomePostData, { headers: getHeader() }),
                axios.put(services.financial_proposal + table_name + '/' + netIncomeItem.customer_income_id, netIncomePostData, { headers: getHeader() }),
                axios.put(services.financial_proposal + table_name + '/' + customer_income_id, postData, { headers: getHeader() })
            ]).then(response => {
                _gNotif.notifySuccess('Net Income updated successfully.', 2000);
            }).catch(error => {
                _gNotif.errorFunction(error, "Error Saving Admin Value")
            });
        }, 1500),
        updateExpenseValue: debounce(function (expense) {
            let new_admin_value = null;
            let new_customer_value = null;
            let admin_value = expense.admin_month_value;
            let customer_value = expense.customer_month_value;
            if (expense.frequency_id == 1) {
                new_admin_value = admin_value * 12;
                new_customer_value = customer_value * 12;
            }
            else {
                new_admin_value = admin_value;
                new_customer_value = customer_value
            }

            if (admin_value == '' || admin_value == null) {
                new_admin_value = null;
            }

            if (customer_value == '' || customer_value == null) {
                new_customer_value = null;
            }

            const postData = {
                customer_value: new_customer_value,
                admin_value: new_admin_value,
            }
            axios.put(services.financial_proposal + 'customer_expense/' + expense.customer_expense_id, postData, { headers: getHeader() })
                .then(response => {
                    this.emitEvent()
                })
                .catch(error => {
                    _gNotif.errorFunction(error, "Error Saving Admin Value")
                });
        }, 1000),
        updateData: debounce(function (customer_liability_id, curr_installment) {
            const postData = {
                admin_curr_installment: curr_installment,
            }
            axios.put(services.financial_proposal + 'customer_liability/' + customer_liability_id, postData, { headers: getHeader() })
                .then(response => {
                    // this.generateChart();
                    this.emitEvent()
                })
                .catch(error => {
                    // console.log(error.response.status)
                    _gNotif.errorFunction(error, "Error Saving Admin Value")
                });
        }, 1000),
        updateNetIncome: debounce(function (auto_net_income = null) {
            let admin_value = 0;

            if (auto_net_income == null) {
                admin_value = this.customer_manual_net_income
            }
            else {
                admin_value = auto_net_income
            }

            const postData = {
                admin_value: admin_value == 0 ? null : admin_value,
            }
            axios.put(services.financial_proposal + 'customer_income/' + this.customer_net_income[0].customer_income_id, postData, { headers: getHeader() })
                .then(response => {
                    if (response.status == 200) {
                        this.emitEvent()
                        this.$emit('refresh-financial');
                        _gNotif.notifySuccess('Net Income auto updated successfully.', 2000);
                        // initialProposalEventBus.$emit('get-net-income', this.customer_manual_net_income);
                    }
                })
                .catch(error => {
                    _gNotif.errorFunction(error, "Error Saving Admin Value")
                });
        }, 3000),
        // using different variable, because the one inside financial_proposal.customer_incomes.total is being used on the total
        getCustomerNetIncome() {
            this.customer_net_income = this.financial_proposal.customer_incomes.data.filter(item => item.object_title == 'net_income');
            if (this.customer_net_income.length > 0) {
                if (this.customer_net_income[0].admin_value != null && this.customer_net_income[0].admin_value != this.customer_manual_net_income) {
                    this.is_manual_net_income = true;
                    this.customer_manual_net_income = this.customer_net_income[0].admin_value;
                } else {
                    this.is_manual_net_income = false;
                    this.customer_manual_net_income = null;
                }
            }
        },
        emitEvent: debounce(function () {
            initialProposalEventBus.$emit('get-financial-proposal')
            this.$notify({
                message:
                    '<b>Auto Update Completed.</b> ',
                timeout: 2000,
                icon: 'ni ni-bell-55',
                type: 'success',
            });
        }, 5000),
        getInputStyle(admin_value, customer_value) {
            return {
                backgroundColor: admin_value !== customer_value ? 'lightblue' : 'transparent'
            };
        },
    },
}
</script>